import * as React from 'react';
/** Allows access to current auth state via React context */
export const FileContext = React.createContext({
    exportImages: (options) => { throw new Error("Not implemented"); },
    exportThumbnail: () => { throw new Error("Not implemented"); },
});
